import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import Features from './Components/Features';

import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react';
import Home from './Home';
import { Pricing } from './Components/Pricing';


function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 600,
      easing: 'ease-out-sine',
    })
  })

  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path="/features" element={<Features shownavbar={true} />} />
        <Route path="/pricing" element={<Pricing />}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
